// extracted by mini-css-extract-plugin
module.exports = {"SecurityBadges":"SecurityBadges_SecurityBadges__RilZo"};